import * as actions from './actions'
import { saveEntities } from '../factories'
import { showFeedback } from '../feedback/factories'

export const find = [
  //
  actions.find,
  saveEntities(),
]

export const findForList = [
  //
  actions.find,
  actions.setList,
  saveEntities(),
]

export const get = [
  //
  actions.get,
  saveEntities(),
]

export const save = [
  //
  actions.save,
  actions.clearList,
  saveEntities(),
  showFeedback({ title: 'Season has been updated', type: 'success' }),
  findForList,
]

export const remove = [
  //
  actions.remove,
  showFeedback({ title: 'Season deleted', type: 'success' }),
  findForList,
]
